<template>
<!-- contents -->
<div id="contents">
    <div class="contents_wrap">
        <!-- contents_head -->
        <!-- breadcrumbs -->
        <skp-breadcrumbs @page-title="val => pageTitle = val" />
        <!-- //breadcrumbs -->
        <h2 class="pg_title">{{ pageTitle }}</h2>
        <!-- //contents_head -->

        <!-- srchTop_wrap -->
        <div class="srchTop_wrap srch_mypage">
            <article class="srch_detail">
                <dl class="dl_select">
                    <dt class="text-bold">{{ $t('FIELD.GLOBAL.SUBSIDIARY') }}<em class="txt_mandatory">*</em></dt>
                    <dd data-input-type="select">
                        <!-- 200715수정 S -->
                        <fieldset class="ui_fieldset set_2">
                            <div>
                                <select
                                    id="SEL_REGION_CD"
                                    name="SEL_REGION_CD"
                                    v-model="SEL_REGION_CD"
                                    class="slt_white w100p"
                                    @change="changeRegionCd($event)"
                                >
                                    <option value="" disabled selected>{{ $t('FIELD.GLOBAL.SELECT') }}</option>
                                    <option v-for="(item, index) in selRegionList"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select
                                    id="SEL_CORP_CD"
                                    name="SEL_CORP_CD"
                                    v-model="SEL_CORP_CD"
                                    class="slt_white w100p"
                                    @change="changeCorpCd($event)"
                                >
                                    <option value="" disabled selected>{{ $t('FIELD.GLOBAL.SELECT') }}</option>
                                    <option v-for="(item, index) in selCorpList"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </dd>
                </dl>
                <dl class="dl_select">
                    <dt>{{ $t('FIELD.GLOBAL.MENU') }}</dt>
                    <dd data-input-type="select">
                        <!-- 200715수정 S -->
                        <fieldset class="ui_fieldset set_2">
                            <div>
                                <select
                                    id="BOARD_TYPE1"
                                    name="BOARD_TYPE1"
                                    v-model="BOARD_TYPE1"
                                    class="slt_white w100p"
                                    @change="changeBoardType1($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                    <option v-show="boardType1List.length > 0"
                                            v-for="item in boardType1List"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select
                                    id="BOARD_TYPE2"
                                    name="BOARD_TYPE2"
                                    v-model="BOARD_TYPE2"
                                    class="slt_white w100p"
                                    @change="changeBoardType2($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                    <option v-show="boardType2List.length > 0"
                                            v-for="item in boardType2List"
                                            :key="item.code"
                                            :value="item.code"
                                            :data-menu-grp-dtl-cd="item.menuGrpDtlCd"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </dd>
                </dl>
                <dl class="dl_select">
                    <dt>{{ $t('FIELD.GLOBAL.CATEGORY') }}</dt>
                    <dd data-input-type="select">
                        <!-- 200715수정 S -->
                        <fieldset class="ui_fieldset set_3">
                            <div>
                                <select class="slt_white w100p"
                                        id="PRD_CATEGORY_CD1"
                                        v-model="PRD_CATEGORY_CD1"
                                        @change="changeCategory1($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                    <option v-show="categoryComboList1.length > 0"
                                            v-for="item in categoryComboList1"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select class="slt_white w100p"
                                        id="PRD_CATEGORY_CD2"
                                        v-model="PRD_CATEGORY_CD2"
                                        @change="changeCategory2($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                    <option v-show="categoryComboList2.length > 0"
                                            v-for="item in categoryComboList2"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select class="slt_white w100p"
                                        id="PRD_CATEGORY_CD3"
                                        v-model="PRD_CATEGORY_CD3"
                                >
                                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                    <option v-show="categoryComboList3.length > 0"
                                            v-for="item in categoryComboList3"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </dd>
                </dl>
                <dl class="dl_input">
                    <dt>{{ $t('FIELD.GLOBAL.REGISTERED.DATE') }}</dt>
                    <dd data-input-type="date">
                        <fieldset class="ui_fieldset">
                            <span class="date-wrap">
                                <label>
                                    <input id="fromDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                    <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                </label>
                                <div id="from-picker-container" style="margin-top: -1px;"/>
                            </span>
                            <em class="txt_space"></em>
                            <span class="date-wrap">
                                <label>
                                    <input id="toDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                    <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                </label>
                                <div id="to-picker-container" style="margin-top: -1px;"/>
                            </span>
                        </fieldset>
                    </dd>
                </dl>
                <dl class="dl_search">
                    <dt>{{ $t('FIELD.GLOBAL.STATUS') }}</dt>
                    <dd data-input-type="select">
                        <select class="slt_white w100p"
                                id="searchStatus"
                                v-model="searchStatus"
                        >
                            <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                            <option v-show="statusComboList.length > 0"
                                    v-for="item in statusComboList"
                                    :key="item.code"
                                    :value="item.code"
                            >{{item.codeName}}</option>
                        </select>
                    </dd>
                    <dd class="clearable" data-input-type="input">
                        <input  id="searchTitle"
                                name="searchTitle"
                                type="text"
                                class="text_input w100p"
                                maxlength="200"
                                v-model.trim="searchTitle"
                                :placeholder="$t('FIELD.PLACEHOLDER.KNOWLEDGE.RESULTSEARCH')"
                                @keyup.enter.stop="handleSearch"
                                v-clearable
                        >
                        <i class="clearable_clear">{{ $t('BUTTON.GLOBAL.DELETE') }}</i>
                    </dd>
                </dl>
                <!-- 200714수정 S -->
                <span class="srch_mypage_btn">
                    <a href="javascript:" class="btn_srch" @click="handleSearch">{{ $t('BUTTON.GLOBAL.SEARCH') }}</a>
                </span>
            </article>
        </div>

        <div class="tab_wrap">
            <ul class="tab_menu_04 tab_menus">
                <li :class="showType === 'HQ' ? 'on' : ''">
                    <a href="javascript:" @click="changeShowType('HQ')">{{ $t('FIELD.REPROCESS.TAB.HQCONTENTS') }}</a>
                </li>
                <li :class="showType === 'RE' ? 'on' : ''">
                    <a href="javascript:" @click="changeShowType('RE')">{{ $t('FIELD.REPROCESS.TAB.RECOMMEND') }}</a>
                </li>
            </ul>
            <div class="tab_contents">
                <div class="tab_cont" v-if="showType === 'HQ'">
                    <!-- Grid -->
                    <div class="grid_wrap" v-resize="setHQGridResizeColumn">
                        <div class="btn_wrap" v-show="getBoardCreationYN == 'Y'">
                            <a href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.DELETE.TODO.LIST')" @click="btnDeleteToDoList">{{ $t('BUTTON.GLOBAL.DELETE.TODO.LIST') }}</a>
                            <a href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.ADD.CONTENTS')" @click="btnAddContents">{{ $t('BUTTON.GLOBAL.ADD.CONTENTS') }}</a>
                            <a href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.EXCELDOWNLOAD')" @click="btnExcelDownload">{{ $t('BUTTON.GLOBAL.EXCELDOWNLOAD') }}</a>
                        </div>
                        <hq-cont-grid
                            :gridId="hqGridId"
                            :ref="hqGridId"
                            :columns="hqColumns"
                            :data="hqGridData"
                            :options="options"
                            :pageOptions="pageOptions"
                            :isTotalCount="true"
                            :click="contentClick"
                            @grid-total-count="setTotalCount"
                        ></hq-cont-grid>
                        <div class="paginate">
                            <sdl-pagination
                                align="center"
                                :current-page="hqCurrentPage"
                                :total-rows="hqTotalCount"
                                :per-page="perPage"
                                @change="movePage"
                            />
                        </div>
                    </div>
                </div>
                <div class="tab_cont" v-else-if="showType === 'RE'">
                    <!-- Grid -->
                    <div class="grid_wrap" v-resize="setREGridResizeColumn">
                        <div class="btn_wrap" v-show="getBoardCreationYN == 'Y'">
                            <a href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.DELETE.TODO.LIST')" @click="btnDeleteToDoList">{{ $t('BUTTON.GLOBAL.DELETE.TODO.LIST') }}</a>
                            <a href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.ADD.CONTENTS')" @click="btnAddContents">{{ $t('BUTTON.GLOBAL.ADD.CONTENTS') }}</a>
                            <a href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.EXCELDOWNLOAD')" @click="btnExcelDownload">{{ $t('BUTTON.GLOBAL.EXCELDOWNLOAD') }}</a>
                        </div>
                        <recommend-grid
                            :gridId="reGridId"
                            :ref="reGridId"
                            :columns="reColumns"
                            :data="reGridData"
                            :options="options"
                            :pageOptions="pageOptions"
                            :isTotalCount="true"
                            :click="contentClick"
                            @grid-total-count="setTotalCount"
                        ></recommend-grid>
                        <div class="paginate">
                            <sdl-pagination
                                align="center"
                                :current-page="reCurrentPage"
                                :total-rows="reTotalCount"
                                :per-page="perPage"
                                @change="movePage"
                            />
                        </div>
                    </div>
                </div>
            </div><!-- //tab_contents -->
        </div><!-- //tab_wrap -->

    </div>
</div>
<!-- contents -->
</template>
<script>
import Vue                                  from 'vue';
import axios                                from 'axios';
import qs                                   from 'query-string';
import { mapGetters, mapActions }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import moment                               from 'moment';
import resize                               from 'vue-resize-directive'
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLPagination                        from '~~c/control/pagination/Pagination';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import DatePicker                           from '~c/DatePicker';

import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';
import ExcelDownloadPopup                   from '~vb/common/ExcelDownloadPopup';

import HQContentsListGrid                   from './HQContentsListGrid';
import RecommendationListGrid               from './RecommendationListGrid';

import ServiceScriptDeletePopup             from './popup/ServiceScriptDeletePopup';

require('moment-jdateformatparser');

export default {
    name: 'ServiceScriptList',
    data() {
    	return {
            pageTitle: '',
            showType: 'HQ',
            serviceScriptList: [],

            SEL_REGION_CD: '',
            SEL_CORP_CD: '',
            selRegionList: [],
            selCorpList: [],
            qSelRegionCd: '',
            qSelCorpCd: '',

            BOARD_TYPE1: '',            // board Type - board parent id
            BOARD_TYPE2: '',            // board Type - board id
            boardType1List: [],         // board Type List 1
            boardType2List: [],         // board Type List 2
            qBoardType1: '',            // ReSearch BoardType
            qBoardType2: '',            // ReSearch BoardType
            qBoardType3: '',            // ReSearch BoardType

            PRD_CATEGORY_CD1: '',       // Category 1
            PRD_CATEGORY_CD2: '',       // Category 2
            PRD_CATEGORY_CD3: '',       // Category 3
            categoryComboList1: [],     // Category 1 List
            categoryComboList2: [],     // Category 2 List
            categoryComboList3: [],     // Category 3 List
            qCategory1: '',             // Quick Category Value 1
            qCategory2: '',             // Quick Category Value 2
            qCategory3: '',             // Quick Category Value 3

            searchStatus: '',           // Status
            statusComboList: [],        // Status List

            searchTitle: '',            // Subject
            rangePicker: null,

            hqGridId: 'hqContentsList',
            hqColumns: [],
            hqGridData: [],
            hqTotalCount: 0,
            hqPageNo: 1,
            hqCurrentPage: 1,

            reGridId: 'recommendationList',
            reColumns: [],
            reGridData: [],
            reTotalCount: 0,
            rePageNo: 1,
            reCurrentPage: 1,

            options: {},
            pageOptions: {},
            perPage: 20
    	}
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            loginRhq: 'getLoginRhq',
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            deptLevelCd: 'getDeptLevelCd',
            params: 'getParams',
            locale: 'getLocale',
            menus: 'getMenus',
        }),
        getUserInfo()           { return SDLUtil.getLoginedUserInfo() || {}; },
        getUserRole()           { return this.userRoles || []; },
        getUserCorpCd()         { return this.userCorpCd || ''; },
        getBoardCreationYN()    { return this.params.creationYn || 'N'; },
        getScrapWorkCode()      { return MenuUtil.getScrapWorkCode(); },
        getLoginNo()            { return this.loginNo || ''; },
        getLoginRHQCd()         { return (!StringUtil.isNull(this.qSelRegionCd)) ? this.qSelRegionCd : this.loginRhq || ''; },
        getSelCorpCd()          { return (!StringUtil.isNull(this.qSelCorpCd)) ? this.qSelCorpCd : this.SEL_CORP_CD || ''; },
        getSelBoardType1()      { return (!StringUtil.isNull(this.qBoardType1)) ? this.qBoardType1 : this.BOARD_TYPE1 || ''; },
        getSelBoardType2()      { return (!StringUtil.isNull(this.qBoardType2)) ? this.qBoardType2 : this.BOARD_TYPE2 || ''; },
        getSelCategory1()       { return (!StringUtil.isNull(this.qCategory1)) ? this.qCategory1 : this.PRD_CATEGORY_CD1 || ''; },
        getSelCategory2()       { return (!StringUtil.isNull(this.qCategory2)) ? this.qCategory2 : this.PRD_CATEGORY_CD2 || ''; },
        getSelCategory3()       { return (!StringUtil.isNull(this.qCategory3)) ? this.qCategory3 : this.PRD_CATEGORY_CD3 || ''; },
        getPageNo()             { return (this.showType === 'HQ') ? this.hqPageNo : this.rePageNo; },
        getReSearch()           { return this.$route.query.reSearch || 'N'; },
        getShowType()           { return this.$route.query.showType || 'HQ'; },
        getFromDate() {
            const boardParams = SDLUtil.getBoardSearchParams('ServiceScript') || { searchParams: {} },
                  mFormat = localStorage.getItem('mDateFormat');    // moment dateformat
            if(typeof(boardParams.searchParams) !== 'undefined' && typeof(boardParams.searchParams.searchFromAddDt) !== 'undefined') {
                let date = boardParams.searchParams.searchFromAddDt;
                return moment(date, mFormat).toDate();

            } else {
                return null;
            }
        },
        getToDate() {
            const boardParams = SDLUtil.getBoardSearchParams('ServiceScript') || { searchParams: {} },
                  mFormat = localStorage.getItem('mDateFormat');    // moment dateformat
            if(typeof(boardParams.searchParams) !== 'undefined' && typeof(boardParams.searchParams.searchToAddDt) !== 'undefined') {
                let date = boardParams.searchParams.searchToAddDt;
                return moment(date, mFormat).toDate();

            } else {
                return null;
            }
        }
    },
    directives: { resize },
    components: {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
        'sdl-pagination'    : SDLPagination,
        'hq-cont-grid'      : HQContentsListGrid,
        'recommend-grid'    : RecommendationListGrid,
    },
    methods: {
        ...mapActions([ 'setParams' ]),
        // 처음 로딩 시
        initLoad() {
            SDLUtil.showLoadingBar(true);
            // 그리드 컬럼 세팅
            this.hqColumns = this.getHQDynamicCols();
            // 지역목록 로드 후 게시판 타입 1 로드
            this.setRegionList().then(() => {
                this.setCorpList().then(() => {
                    this.setBoardType1().then(() => {
                        this.setBoardType2();
                    })
                })
            });
            // 초기 카테고리1 리스트 로드
            this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                this.categoryComboList1 = data;
            });
            // 초기 상태 리스트 로드
            this.setStatusList();
            SDLUtil.showLoadingBar(false);

            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        changeShowType(tab) {
            if(this.showType !== tab) {
                this.showType = tab;
                if(tab === 'HQ') {
                    this.hqColumns = this.getHQDynamicCols();
                    this.hqTotalCount = 0;
                    this.hqPageNo = 1;
                    this.hqCurrentPage = 1;
                } else {
                    this.reColumns = this.getREDynamicCols();
                    this.reTotalCount = 0;
                    this.rePageNo = 1;
                    this.reCurrentPage = 1;
                }

                this.serviceScriptList = [];
                this.$nextTick(() => {
                    this.handleSearch();
                });
            }
        },
        // Code combo list api
        async getCodeComboList(categoryVal, categoryCode, addCondition) {
            let additionalValue = (['RHQ_AUTH_ACCESS_CD', 'SUB_AUTH_ACCESS_CD'].includes(categoryCode)) ? this.getLoginNo : this.getUserCorpCd;
            // BOARD_TYPE2 의 경우, 선택된 corpCd 를 넘겨준다.
            if(categoryCode === 'BOARD_TYPE2') { additionalValue = this.getSelCorpCd; }
            const codeResp = await api.getComboList(categoryVal, categoryCode, additionalValue);
            return codeResp;
        },
        getComboBoxVal(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).value : "";
        },
        getComboBoxName(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).name : "";
        },
        // 권한체크
        isAllUser(){
            if(
                this.getUserRole.includes(`${constants.SYSTEM_ADMIN}`)
             || this.getUserRole.includes(`${constants.GBM_ADMIN}`)
             || this.getUserRole.includes(`${constants.RHQ_ADMIN}`)
            ) {
                return true;
            } else {
                return false;
            };
        },
        setRegionList() {
            let that = this;
            return new Promise(function(resolve) {
                that.getCodeComboList(that.loginNo, "RHQ_AUTH_ACCESS_CD")
                    .then(data => {
                        that.selRegionList = data;
                        that.SEL_REGION_CD = that.getLoginRHQCd;

                        setTimeout( function(){ resolve(); }, 100 );
                    });
            });
        },
        setCorpList() {
            let that = this;
            return new Promise(function(resolve) {
                that.getCodeComboList(that.getLoginRHQCd, "SUB_AUTH_ACCESS_CD")
                    .then(data => {
                        that.selCorpList = data;
                        that.SEL_CORP_CD = that.getUserCorpCd;

                        setTimeout( function(){ resolve(); }, 100 );
                    });
            });
        },
        // Board1 setting
        setBoardType1() {
            let that = this;
            return new Promise(function(resolve) {
                that.getCodeComboList(that.getSelCorpCd, "BOARD_TYPE1").then(data => {
                    that.BOARD_TYPE1    = that.getSelBoardType1,
                    that.boardType1List = data;

                    setTimeout( function(){ resolve(); }, 100 );
                });
            });
        },
        // Board2 setting
        setBoardType2() {
            let that = this;
            that.getCodeComboList(that.getSelBoardType1, "BOARD_TYPE2").then(data => {
                that.BOARD_TYPE2    = that.getSelBoardType2;
                that.boardType2List = data;
            });
        },
        // 지역 코드 변경 이벤트
        changeRegionCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue === "") {
                this.selCorpList    = [], this.SEL_CORP_CD = '';
                this.boardType1List = [], this.BOARD_TYPE1 = '';
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.getCodeComboList(comboValue, "SUB_AUTH_ACCESS_CD").then(data => {
                    this.selCorpList    = data, this.SEL_CORP_CD = '';
                    this.boardType1List = [],   this.BOARD_TYPE1 = '';
                    this.boardType2List = [],   this.BOARD_TYPE2 = '';
                });
            }
        },
        changeCorpCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue === "") {
                this.boardType1List = [], this.BOARD_TYPE1 = '';
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.getCodeComboList(comboValue, "BOARD_TYPE1").then(data => {
                    this.boardType1List = data, this.BOARD_TYPE1 = '';
                    this.boardType2List = [],   this.BOARD_TYPE2 = '';
                });
            }
        },
        // Board1 combo change event => create Board2 combo list
        changeBoardType1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.getCodeComboList(comboValue, "BOARD_TYPE2").then(data => {
                    this.boardType2List = data;
                    this.BOARD_TYPE2    = '';
                });
            }
        },
        // Board2 combo change event
        changeBoardType2(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue !== "") {
                let selMenuGrpDtlCd = document.getElementById('BOARD_TYPE2').selectedOptions[0].getAttribute('data-menu-grp-dtl-cd');
            }
        },
        // 첫번째 카테고리 설정
        setCategory1() {
            let that = this;
            return new Promise(function(resolve) {
                that.getCodeComboList(that.getSelCategory1, "ADM_CATEGORY_B").then(data => {
                    that.PRD_CATEGORY_CD1 = that.getSelCategory1;
                    that.categoryComboList2 = data;

                    setTimeout( function(){ resolve(); }, 100 );
                });
            });
        },
        // 두번째 카테고리 설정
        setCategory2() {
            let that = this;
            return new Promise(function(resolve) {
                that.getCodeComboList(that.getSelCategory2, "ADM_CATEGORY_C").then(data => {
                    that.PRD_CATEGORY_CD2 = that.getSelCategory2;
                    that.categoryComboList3 = data;
                    that.PRD_CATEGORY_CD3 = that.getSelCategory3;
                    
                    setTimeout( function(){ resolve(); }, 100 );
                });
            });
        },
        // 첫번째 카테고리 변경 이벤트
        changeCategory1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.categoryComboList2 = [], this.PRD_CATEGORY_CD2 = '';
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';

            } else {
                this.getCodeComboList(comboValue, "ADM_CATEGORY_B").then(data => {
                    this.PRD_CATEGORY_CD2 = '';
                    this.categoryComboList2 = data;
                });

                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
            }
        },
        // 두번째 카테고리 변경 이벤트
        changeCategory2(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';

            } else {
                this.getCodeComboList(comboValue, "ADM_CATEGORY_C").then(data => {
                    this.PRD_CATEGORY_CD3 = '';
                    this.categoryComboList3 = data;
                });
            }
        },
        // Status Combo list
        setStatusList(status = 'R') {
            SDLUtil.getCommCodeList('SERVICE_SCRIPT_STATUS').then(data => {
                this.searchStatus = status;
                this.statusComboList = data;
            });
        },
        // 그리드 컬럼 percent resize 용
        getHQDynamicCols() {
            return [
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.TYPE'), name: 'BOARD_TYPE_NM', align: 'left', width: this.getColumnSize(16), resizable: true, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY'), name: 'PRD_CATEGORY_NM', align: 'left', width: this.getColumnSize(24), resizable: true, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBJECT'), name: 'KNOWLEDGE_TITLE', align: 'left', width: this.getColumnSize(22), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.STATUS'), name: 'STATUS_NM', align: 'center', width: this.getColumnSize(8), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.ADDED.ON'), name: 'REG_DT', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.DUE.DATE'), name: 'DUE_DATE', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.ADDED.BY'), name: 'REG_USER_NM', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: true },
                { header: 'KNOWLEDGE_ID', name: 'KNOWLEDGE_ID', hidden: true },
                { header: 'SERVICE_SCRIPT_ID', name: 'SERVICE_SCRIPT_ID', hidden: true },
            ];
        },
        setHQGridResizeColumn(e) {
            EventBus.$emit('hq-cont-grid-set-column', this.getHQDynamicCols());
        },

        // 그리드 컬럼 percent resize 용
        getREDynamicCols() {
            return [
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.TYPE'), name: 'BOARD_TYPE_NM', align: 'left', width: this.getColumnSize(16), resizable: true, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY'), name: 'PRD_CATEGORY_NM', align: 'left', width: this.getColumnSize(24), resizable: true, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBJECT'), name: 'KNOWLEDGE_TITLE', align: 'left', width: this.getColumnSize(22), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.STATUS'), name: 'STATUS_NM', align: 'center', width: this.getColumnSize(8), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.ADDED.ON'), name: 'REG_DT', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.DUE.DATE'), name: 'DUE_DATE', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.ADDED.BY'), name: 'REG_USER_NM', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: true },
                { header: 'KNOWLEDGE_ID', name: 'KNOWLEDGE_ID', hidden: true },
                { header: 'SERVICE_SCRIPT_ID', name: 'SERVICE_SCRIPT_ID', hidden: true },
            ];
        },
        setREGridResizeColumn(e) {
            EventBus.$emit('recommend-grid-set-column', this.getREDynamicCols());
        },
        getColumnSize(size) {
            if(isNaN(Number(size))) { return 0; }
            let gridWrapSize = document.getElementsByClassName('grid_wrap').length ? document.getElementsByClassName('grid_wrap')[0].clientWidth - 16 : 1000;
            return Math.floor((gridWrapSize - 50) / (100 / size));
        },
        // 그리드 컬럼 percent resize 용

        // 컨텐츠 클릭 이벤트
        contentClick(e, rowData, grid) {
            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;
            let row = rowData.find(function(r){ return r.rowKey === e.rowKey });
            let KNOWLEDGE_ID = row['KNOWLEDGE_ID'] || '',
                SERVICE_SCRIPT_ID = row['SERVICE_SCRIPT_ID'] || '';
            Vue.$log.info('▶ ServiceScriptList.vue contentClick event. =>', row, KNOWLEDGE_ID, SERVICE_SCRIPT_ID);

            if(StringUtil.isNull(SERVICE_SCRIPT_ID)) {
                // Notice Detail
                // "/basis/noticeRegister/noticeRegisterViewPop.skp?KNOWLEDGE_ID=" + knowledgeId.split(",")[0] + "&locationType=Reprocess&perocessStatus="+status;

            } else {
                if(!StringUtil.isNull(KNOWLEDGE_ID) && !StringUtil.isNull(SERVICE_SCRIPT_ID)) {
                    window.scrollTo(0, 0);
                    const params = {
                        KNOWLEDGE_ID: KNOWLEDGE_ID,
                        SERVICE_SCRIPT_ID: SERVICE_SCRIPT_ID,
                        reProcessCorpNo: this.getSelCorpCd,
                        TYPE: this.showType
                    };

                    return this.$router.push({ name: 'ServiceScriptDetail', query: params });
                }
            }
        },
        // 페이지 이동
        movePage(pageNo) {
            if(this.showType === 'HQ') {
                this.hqCurrentPage = pageNo;
            } else {
                this.reCurrentPage = pageNo;
            }

            this.handlePageSearch(pageNo);
        },
        // 총 합계 설정
        setTotalCount(totCnt) {
            if(this.showType === 'HQ') {
                this.hqTotalCount = totCnt;
            } else {
                this.reTotalCount = totCnt;
            }
        },
        // 현재 페이지 설정
        setCurrentPage(page) {
            if(this.showType === 'HQ') {
                this.hqCurrentPage = page;
            } else {
                this.reCurrentPage = page;
            }
        },
        // 그리드 체크시 serviceScriptId 를 선택함
        setCheckedList(rtnList = []) {
            Vue.$log.info(rtnList);
            this.serviceScriptList = rtnList;
        },
        setBoardParams(params) {
            // 검색 시, Search Parameter 를 vuex store에 저장한다.
            let storeParams = this.params,
                storeBoardId = 'ServiceScript';
            let boardParams = storeParams['boardParams'] || [];
            let boardIdx = boardParams.length > 0 ? _.findIndex(boardParams, function(b){ return b.boardId === storeBoardId; }) : null;

            if(boardIdx < 0){
                boardParams.push({
                    boardId: storeBoardId,
                    searchParams: this.setSearchParameter()
                });

            } else {
                if(StringUtil.isNull(boardIdx)) boardIdx = boardParams.length;
                boardParams[boardIdx] = {
                    boardId: storeBoardId,
                    searchParams: this.setSearchParameter()
                };
            }

            storeParams['boardParams'] = boardParams;
            this.setParams(storeParams);

            return Object.assign({ BOARD_ID: 'ServiceScript' }, this.setSearchParameter());
        },
        // Search Parameter setting
        setSearchParameter() {
            let mFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            this.searchTitle = (SDLUtil.nvl(this.searchTitle)).toUpperCase();

            if(StringUtil.isNull(this.getSelCorpCd)) {
                return SDLUtil.alert('MESSAGE.GROBAL.SELECT.SUBSIDIARY');
            };

            return {
                SEARCH_TYPE: this.showType,
                selectRegionNo: this.SEL_REGION_CD,
                selectCorpNo: this.getSelCorpCd,
                BOARD_TYPE1: this.getSelBoardType1,
                BOARD_TYPE2: this.getSelBoardType2,
                PRD_CATEGORY_CD1: this.PRD_CATEGORY_CD1 || '',
                PRD_CATEGORY_CD2: this.PRD_CATEGORY_CD2 || '',
                PRD_CATEGORY_CD3: this.PRD_CATEGORY_CD3 || '',
                searchStatus: this.searchStatus,
                searchTitle: this.searchTitle,
                searchFromAddDt: this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : '',
                searchToAddDt: this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : '',
                ORDER_COLUMN: this.ORDER_COLUMN || '',
                ORDER_ASC: this.ORDER_ASC || '',
                page: this.getPageNo
            }
        },
        // 정렬 조회 - 정렬로 조회하는 경우, 페이지를 1로 초기화 한다.
        handleSortSearch(sortObj) {
            if(!StringUtil.isNull(sortObj.orderColName)) {
                this.ORDER_COLUMN = sortObj.orderColName;
                this.ORDER_ASC = sortObj.ascending ? "ASC" : "DESC";
            } else {
                this.ORDER_COLUMN = '';
                this.ORDER_ASC = '';
            }

            this.handlePageSearch(1);
        },
        // 페이지 조회
        handlePageSearch(pageNo){
            if(pageNo !== null && pageNo != "") {
                if(this.showType === 'HQ') {
                    this.hqPageNo = pageNo;
                } else {
                    this.rePageNo = pageNo;
                }

                this.handleSearch();

            } else {
                Vue.$log.warn('Page no is null');
            }
        },
        // 조회
        handleSearch() {
            const boardParams = this.setSearchParameter();
            this.setBoardParams(boardParams);
            if(this.showType === 'HQ') {
                EventBus.$emit('hq-cont-grid-search', boardParams);

            } else {
                EventBus.$emit('recommend-grid-search', boardParams);
            }
        },
        // 재조회
        reSearch(pageNo) {
            this.pageNo = this.$route.query.page || 1;
            this.handlePageSearch(pageNo);
        },
        // 검색 파라미터 세팅
        setSearchParams() {
            const boardParams = SDLUtil.getBoardSearchParams('ServiceScript');
            const sParams = boardParams.searchParams || {};
            Vue.$log.info('ServiceScript searchParams =>', sParams);
            
            // 날짜 세팅
            this.rangePicker.setStartDate(this.getFromDate);
            this.rangePicker.setEndDate(this.getToDate);

            // 상태 코드와 제목
            this.setStatusList(sParams.searchStatus);
            this.searchTitle    = sParams.searchTitle;

            // 카테고리 목록
            this.setQuickCategoryParam({
                searchPRD_CATEGORY_CD1: sParams.PRD_CATEGORY_CD1,
                searchPRD_CATEGORY_CD2: sParams.PRD_CATEGORY_CD2,
                searchPRD_CATEGORY_CD3: sParams.PRD_CATEGORY_CD3
            });

            this.qSelRegionCd   = sParams.selectRegionNo;
            this.qSelCorpCd     = sParams.selectCorpNo;
            this.qBoardType1    = sParams.BOARD_TYPE1;
            this.qBoardType2    = sParams.BOARD_TYPE2;

            // 지역목록 로드 후 게시판 타입 1 로드
            this.setRegionList().then(() => {
                this.setCorpList().then(() => {
                    this.setBoardType1().then(() => {
                        this.setBoardType2();
                    })
                })
            });
        },
        btnDeleteToDoList() {
            if(this.deptLevelCd === 1) {
                return SDLUtil.alert('MESSAGE.AUTHORITY.NOHAVE');
            };

            if(this.serviceScriptList.length === 0) {
                return SDLUtil.alert('MESSAGE.DATA.CHECKDELETE');
            };

            let chkCnt = 0;
            for(let i = 0; i < this.serviceScriptList.length; i++) {
                let serviceScript = this.serviceScriptList[i];
                if(serviceScript.STATUS === 'C' || serviceScript.DEL_YN === 'Y') {
                    chkCnt++;
                }
            };

            if(chkCnt !== 0) {
                return SDLUtil.alert('MESSAGE.DATA.DELETECHECK');

            } else {
                SDLUtil.show(
                    ServiceScriptDeletePopup,
                    {
                        selectedList: this.serviceScriptList,
                        showType: this.showType,
                        rtnFunc: () => {
                            this.handleSearch();
                        }
                    },
                    { height: 'auto' }
                );
            }
        },
        btnAddContents() {
            if(this.deptLevelCd === 1) {
                return SDLUtil.alert('MESSAGE.AUTHORITY.NOHAVE');
            };

            if(this.serviceScriptList.length !== 1) {
                return SDLUtil.alert('MESSAGE.SELECT.ONLY.ONE');
            };

            let popTitle = SDLUtil.getMsgProp('TITLE.ADD.SERVICE.SCRIPT');
            store.commit('POPUP_PARAMS', {
                title: popTitle,
                knowledgeId: this.serviceScriptList[0].KNOWLEDGE_ID,
                serviceScriptId: this.serviceScriptList[0].SERVICE_SCRIPT_ID,
                isModify: true,
                isServiceScript: true,
                serviceScriptType: this.showType,
                reProcessCorpNo: this.getSelCorpCd,
            });

            let linkUrl = MenuUtil.getRedirectUrl('/basis/myKnowledge/myKnowledge/register/registerForm');
            const detailPop = SDLUtil.openLegacyWindowPopup({ url: linkUrl, title: popTitle, w: 1366, h: 768 });
            let self = this,
                popTimer = window.setInterval(function() {
                if (detailPop.closed !== false) { // !== is required for compatibility with Opera
                    window.clearInterval(popTimer);
                    self.handleSearch();
                }
            }, 200);
        },
        btnExcelDownload() {
            SDLUtil.showLoadingBar(true);
            const formData = this.setSearchParameter();
            return axios.post(
                    `${SDLUtil.API_URL}/basis/myKnowledge/serviceScript/serviceScriptExcel.skp`,
                    qs.stringify( formData ),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                .then(resp => {
                    let that = this;
                    SDLUtil.showLoadingBar(false);
                    if (resp.data.EXCEL_FILES.length > 0) {
                        SDLUtil.show(
                            ExcelDownloadPopup,
                            {
                                title: 'Excel Download - ' + that.pageTitle,
                                excelFiles: resp.data.excelFiles,
                            }, // component params
                            {
                                height: 'auto',
                            }, // dialog params
                        );
                    }
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.showLoadingBar(false);
                });
        },

        // Quick Category Parameter setting
        setQuickCategoryParam(catForm) {
            this.initCategoryParam();
            this.qCategory1 = catForm.searchPRD_CATEGORY_CD1;
            this.qCategory2 = catForm.searchPRD_CATEGORY_CD2;
            this.qCategory3 = catForm.searchPRD_CATEGORY_CD3;

            this.changeCategories();
        },
        // 카테고리 파라미터 초기화
        initCategoryParam() {
            this.qCategory1 = '';
            this.qCategory2 = '';
            this.qCategory3 = '';
            this.PRD_CATEGORY_CD1 = '';
            this.PRD_CATEGORY_CD2 = '';
            this.PRD_CATEGORY_CD3 = '';
            this.categoryComboList1 = [];
            this.categoryComboList2 = [];
            this.categoryComboList3 = [];
        },
        // 모든 카테고리 변경 이벤트, 처음 Mounted 혹은, quick category 를 click 했을 때 호출
        changeCategories() {
            this.setCategory1().then(() => {
                this.setCategory2().then(() => {
                    this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                        this.categoryComboList1 = data;
                    });
                });
            });
        },
        changeSubsidiaries() {
            this.setRegionList.then(() => { this.setCorpList(); });
        }
    },
    created(){
        Vue.$log.info('▶ ServiceScriptList.vue created.');
        this.$nextTick(() => {
            EventBus.$on('page-search',             pageNo      => { this.handlePageSearch(pageNo); });
            EventBus.$on('quick-category',          catForm     => { this.setQuickCategoryParam(catForm); });
            EventBus.$on('hq-cont-sort-search',     sortForm    => { this.handleSortSearch(sortForm); });
            EventBus.$on('hq-cont-checked-list',    rtnList     => { this.setCheckedList(rtnList); });

            EventBus.$on('recommend-sort-search',   sortForm    => { this.handleSortSearch(sortForm); });
            EventBus.$on('recommend-checked-list',  rtnList     => { this.setCheckedList(rtnList); });
        });

        this.showType = this.getShowType;
    },
    mounted(){
        this.initLoad().then(() => {
            this.rangePicker = DatePicker.createRangeWithOpener(
                'from-picker-container', 'fromDate', 'icoFromDate',
                'to-picker-container', 'toDate', 'icoToDate',
                { type: 'date', locale: 'en', showToday: false },
                (new moment()).add(-1, 'month').toDate(),           // 2020.07.03 query 속도로 인해 default를 한 달로 조정
                (new moment()).toDate()
            );

            this.$nextTick(() => {
                if(this.getReSearch === 'Y') {
                    this.setSearchParams();
                }
            });
        });

    },
    beforeDestroy(){
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('page-search');
        EventBus.$off('quick-category');
        EventBus.$off('hq-cont-sort-search');
        EventBus.$off('hq-cont-checked-list');
        EventBus.$off('recommend-sort-search');
        EventBus.$off('recommend-checked-list');
    }
};
</script>

<style>
.tui-datepicker {
    z-index: 9999;
    border: 1px solid #aaa;
    background-color: white;
    position: absolute;
}
.bg_white {
    background-color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/myKnowledge/serviceScript/ServiceScriptList.vue